module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "info-dialog",
    attrs: {
      "title": "添加联系人"
    },
    model: {
      value: (_vm.visiable),
      callback: function($$v) {
        _vm.visiable = $$v
      },
      expression: "visiable"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "84px"
    }
  }, [_c('el-row', {
    attrs: {
      "modal": _vm.contactInfo
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_Name),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_Name", $$v)
      },
      expression: "contactInfo.C_Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_Tel),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_Tel", $$v)
      },
      expression: "contactInfo.C_Tel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职务"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_Position),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_Position", $$v)
      },
      expression: "contactInfo.C_Position"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QQ"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_QQ),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_QQ", $$v)
      },
      expression: "contactInfo.C_QQ"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_Email),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_Email", $$v)
      },
      expression: "contactInfo.C_Email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信",
      "prop": "C_WeiXin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contactInfo.C_WeiXin),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "C_WeiXin", $$v)
      },
      expression: "contactInfo.C_WeiXin"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-053aa460!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/info-dialog/index.vue
// module id = 1370
// module chunks = 1